import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── Voicemails (/api/voicemails) — inbound voicemail recording/transcription (BOOSTT-3178) ─

export type VoicemailStatus = 'recording' | 'completed' | 'failed' | 'no_message';

export type Voicemail = {
  id: string;
  campaign_id?: string | null;
  session_id?: string | null;
  caller_phone?: string | null;
  recording_url?: string | null;
  duration_seconds?: number | null;
  transcript?: string | null;
  transcript_status?: string | null;
  status: VoicemailStatus;
  notified_at?: string | null;
  retention_expires_at?: string | null;
  created_at: string;
};

export async function fetchVoicemails(campaignId?: string, axiosInstance?: AxiosInstance): Promise<Voicemail[]> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<Voicemail[]>(apiConfig.voiceEndpoints.voicemails, { params: { campaign_id: campaignId || undefined } });
  return response.data;
}

export async function deleteVoicemail(id: string, axiosInstance?: AxiosInstance): Promise<void> {
  const client = axiosInstance || getVoiceFallbackClient();
  await client.delete(`${apiConfig.voiceEndpoints.voicemails}/${id}`);
}

// recording_url on Voicemail is Twilio's raw API URL and needs Twilio Basic Auth — this returns a presigned S3 URL a browser can actually play.
export async function fetchVoicemailRecording(id: string, axiosInstance?: AxiosInstance): Promise<{ url: string | null }> {
  const client = axiosInstance || getVoiceFallbackClient();
  const response = await client.get<{ voicemail_id: string; url: string | null }>(`${apiConfig.voiceEndpoints.voicemails}/${id}/recording`);
  return { url: response.data.url };
}
